import { createAction, props } from '@ngrx/store';
import { HttpException } from '@uzurv/core';
import {
  // eslint-disable-next-line no-redeclare
  Document,
  Driver,
  DriverAccountStatus,
  MvrDetails,
  Screening,
  ScreeningPackageStatus,
  SignatureRequestDetail,
  SubstanceScreening,
  TransitProgramDriver
} from '@uzurv/dots';
import { DriverOnboardingProfileState } from './driver-onboarding-profile.reducer';

export const RestoreState = createAction('[Driver Onboarding Profile] Restore state', props<{ state: DriverOnboardingProfileState }>());

export const Start = createAction('[Driver Onboarding Profile] Start', props<{ payload: number }>());

export const GetDriver = createAction('[Driver Onboarding Profile] Get Driver', props<{ id: number }>());

export const GetDriverSuccess = createAction('[Driver Onboarding Profile] Get Driver Success', props<{ driver: Driver }>());

export const GetDriverAccountStatus = createAction('[Driver Onboarding Profile] Get Driver Account Status', props<{ payload: number }>());

export const GetDriverAccountStatusSuccess = createAction(
  '[Driver Onboarding Profile] Get Driver Account Status Success',
  props<{ driverAccountStatus: DriverAccountStatus }>()
);

export const ClearDriverAccountStatus = createAction('[Driver Onboarding Profile] Clear Driver Account Status');

export const FetchTransitProgramDrivers = createAction(
  '[Driver Onboarding Profile] Fetch Transit Program Drivers',
  props<{ id: number }>()
);

export const FetchTransitProgramDriversSuccess = createAction(
  '[Driver Onboarding Profile] Fetch Transit Program Drivers success',
  props<{ transitProgramDrivers: Array<TransitProgramDriver> }>()
);

export const ListActiveDocumentsByDriverIdSuccess = createAction(
  '[Driver Onboarding Profile] List Active Documents By Driver Id Success',
  props<{ documents: Array<Document> }>()
);

export const ListActiveDocumentsByDriverIdFail = createAction(
  '[Driver Onboarding Profile] List Active Documents By Driver Id Fail',
  props<{ error: HttpException }>()
);

export const ListSignatureRequestsByDriverIdSuccess = createAction(
  '[Driver Onboarding Profile] List Signature Requests By Driver Id Success',
  props<{ signatureRequestDetails: Array<SignatureRequestDetail> }>()
);

export const ListSignatureRequestsByDriverIdFail = createAction(
  '[Driver Onboarding Profile] List Signature Requests By Driver Id Fail',
  props<{ error: HttpException }>()
);

export const SetCardOpenState = createAction(
  '[Driver Onboarding Profile] Set card open state',
  props<{ payload: { transitProgramId: number; open: boolean } }>()
);

export const OpenDocument = createAction('[Driver Onboarding Profile] Open document', props<{ document: Document }>());

export const CloseDocument = createAction('[Driver Onboarding Profile] Close document');

export const OpenScreening = createAction('[Driver Onboarding Profile] Open screening', props<{ screening: ScreeningPackageStatus }>());

export const CloseScreening = createAction('[Driver Onboarding Profile] Close screening');

export const OpenMissingSubstanceScreening = createAction(
  '[Driver Onboarding Profile] Open missing screening',
  props<{ screening: ScreeningPackageStatus }>()
);

export const OpenSignatureRequest = createAction(
  '[Driver Onboarding Profile] Open signature request',
  props<{ payload: { request: SignatureRequestDetail; status: string } }>()
);

export const CloseSignatureRequest = createAction('[Driver Onboarding Profile] Close signature request');

export const GetSubstanceScreening = createAction('[Driver Onboarding Profile] Get substance screening');

export const GetSubstanceScreeningSuccess = createAction(
  '[Driver Onboarding Profile] Get substance screening success',
  props<{ substanceScreening: SubstanceScreening }>()
);

export const GetSubstanceScreeningFail = createAction(
  '[Driver Onboarding Profile] Get substance screening fail',
  props<{ error: HttpException }>()
);

export const ClearSubstanceScreening = createAction('[Driver Onboarding Profile] Clear substance screening');

export const ClearSubstanceScreeningCollectionSite = createAction('[Driver Onboarding Profile] Clear substance screening collection site');

export const GetScreeningById = createAction('[Driver Onboarding Profile] Get screening by id', props<{ screeningId: number }>());

export const GetScreeningByIdSuccess = createAction(
  '[Driver Onboarding Profile]  Get screening by id success',
  props<{ screening: Screening }>()
);

export const GetScreeningByIdFail = createAction('[Driver Onboarding Profile] Get screening by id fail', props<{ error: HttpException }>());

export const ClearScreeningById = createAction('[Driver Onboarding Profile] Clear screening by id');

export const GetMVRScreeningDetails = createAction('[Driver Onboarding Profile] Get MVR screening details');

export const GetMVRScreeningDetailsSuccess = createAction(
  '[Driver Onboarding Profile] Get MVR screening details success',
  props<{ mvrOrderDetails: MvrDetails }>()
);

export const GetMVRScreeningDetailsFail = createAction(
  '[Driver Onboarding Profile] Get MVR screening details fail',
  props<{ error: HttpException }>()
);

export const GetMVRReport = createAction('[Driver Onboarding Profile] Get MVR report', props<{ screeningId: number }>());

export const GetMVRReportSuccess = createAction('[Driver Onboarding Profile] Get MVR report success');

export const GetMVRReportFail = createAction('[Driver Onboarding Profile] Get MVR report fail', props<{ error: HttpException }>());

export const ResendScreeningRequest = createAction(
  '[Driver Onboarding Profile] Resend screening request',
  props<{ screeningPackageCode: string; screeningReasonCode: string }>()
);

export const ResendScreeningRequestSuccess = createAction(
  '[Driver Onboarding Profile] Resend screening request success',
  props<{ screening: Screening }>()
);

export const StartNewCriminalScreening = createAction('[Driver Onboarding Profile] Start new criminal screening');

export const StartNewCriminalScreeningSuccess = createAction(
  '[Driver Onboarding Profile] Start new criminal screening success',
  props<{ screening: Screening }>()
);

export const StartNewCriminalScreeningFail = createAction('[Driver Onboarding Profile] Fail', props<{ screening: Screening }>());

export const StartNewMvrScreening = createAction('[Driver Onboarding Profile] Start new MVR screening');

export const StartNewMvrScreeningSuccess = createAction(
  '[Driver Onboarding Profile] Start new MVR screening success',
  props<{ screening: Screening }>()
);

export const StartNewMvrScreeningFail = createAction('[Driver Onboarding Profile] Fail', props<{ screening: Screening }>());

export const Fail = createAction('[Driver Onboarding Profile] Fail', props<{ error: HttpException }>());
